/**
 * 研弈引力 · 服务商后台登录页统一页脚（批次A：与开店宝 / 研弈CRM 对齐）
 *
 * 统一内容（顺序固定）：用户协议 · 隐私政策 · 投诉举报 · 备案号 · © 版权所有
 * 视觉：整页底部吸底、半透明毛玻璃底、白字、12.5px、居中
 * 协议为独立静态页（public/legal/*.html），新标签页打开。
 */

import { Box, Link, Typography } from '@mui/material'

const COMPLAINT_EMAIL = '15221518316@163.com'
const COMPANY = '上海研弈营销策划有限公司'
const ICP = '沪ICP备2026045474号-1'
const GONGAN = '沪公网安备31010702010847号'
const GONGAN_URL = 'https://beian.mps.gov.cn/#/query/webSearch?code=31010702010847'

const linkSx = {
  color: 'inherit',
  textDecoration: 'none',
  '&:hover': { textDecoration: 'underline' },
}

function Sep() {
  return <Box component="span" sx={{ mx: 1, opacity: 0.6 }}>|</Box>
}

export default function SiteFooter() {
  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        py: 1.5,
        px: 2,
        textAlign: 'center',
        background: 'rgba(0,0,0,0.18)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        color: 'rgba(255,255,255,0.9)',
        fontSize: '12.5px',
        lineHeight: 1.7,
        zIndex: 5,
      }}
    >
      <Box sx={{ mb: 0.25 }}>
        <Link
          href="/legal/user-agreement.html"
          target="_blank"
          rel="noopener"
          sx={linkSx}
        >
          用户协议
        </Link>
        <Sep />
        <Link
          href="/legal/privacy-policy.html"
          target="_blank"
          rel="noopener"
          sx={linkSx}
        >
          隐私政策
        </Link>
        <Sep />
        <Link
          href={`mailto:${COMPLAINT_EMAIL}?subject=研弈引力投诉举报`}
          sx={linkSx}
        >
          投诉举报
        </Link>
      </Box>
      <Typography
        variant="caption"
        sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '12px' }}
      >
        © {COMPANY} 版权所有 ·{' '}
        <Link
          href="https://beian.miit.gov.cn"
          target="_blank"
          rel="noopener"
          sx={linkSx}
        >
          {ICP}
        </Link>
        {' · '}
        <Link
          href={GONGAN_URL}
          target="_blank"
          rel="noopener"
          sx={{ ...linkSx, display: 'inline-flex', alignItems: 'center', gap: 0.5, verticalAlign: 'middle' }}
        >
          <Box
            component="img"
            src="/gongan.png"
            alt="公安备案"
            sx={{ width: 13, height: 13, display: 'block' }}
          />
          {GONGAN}
        </Link>
      </Typography>
    </Box>
  )
}
